export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=daac4be6&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/materials/materials-vendors/id/index.vue?vue&type=template&id=daac4be6&
// module id = 1512
// module chunks = 0